import { render, staticRenderFns } from "./a-video.vue?vue&type=template&id=2930eaaa&"
import script from "./a-video.vue?vue&type=script&lang=js&"
export * from "./a-video.vue?vue&type=script&lang=js&"
import style0 from "./a-video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports